import { useFlag } from '@automata/utils/hooks';
import { useMemo } from 'react';

export const useGetInstrumentsState = (workcellId: string) => {
  const isUcbAgilentBiotekUseAllowed = useFlag('fe.ucb_use_agilent_biotek');
  const isUcbAzentaIntellixcapUseAllowed = useFlag(
    'fe.ucb_use_azenta_intellixcap_cap'
  );
  const isUcbZiathBarcodereaderUseAllowed = useFlag(
    'fe.ucb_use_ziath_barcodereader_cap'
  );

  const instrumentStates: Record<string, Record<string, boolean>> = useMemo(
    () => ({
      azProd: {
        agilent_lhc: false,
        biotek: true,
      },
      ucbProd: {
        agilent_biotek: isUcbAgilentBiotekUseAllowed ?? false,
        azenta_intellixcap_cap_1: isUcbAzentaIntellixcapUseAllowed ?? false,
        ziath_barcodereader_cap_1: isUcbZiathBarcodereaderUseAllowed ?? false,
      },
    }),
    [
      isUcbAgilentBiotekUseAllowed,
      isUcbAzentaIntellixcapUseAllowed,
      isUcbZiathBarcodereaderUseAllowed,
    ]
  );

  return instrumentStates[workcellId] ?? {};
};
